/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable guard-for-in */
import {Pipe, PipeTransform} from '@angular/core';
import * as dayjs from 'dayjs';
import * as timezone from 'dayjs/plugin/timezone';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';
import * as utc from 'dayjs/plugin/utc';
import { LocalStorageService } from '../services/localstorage.service';
import { UtilityService } from '../services/utility_functions/utility_functions.service';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

@Pipe({
    name: 'timeformat',
    pure: true
})
export class TimeFormatPipe implements PipeTransform {
    timeFormatObject = {
        '12_HRS' : 'hh:mm A',
        '24_HRS' : 'HH:mm'
    };
    timezone: any = dayjs?.tz?.guess();
    timeFormat: string = this._localStorageService.getLocalStorage('user_preferences').time_format || '12_HRS';
    constructor(private _localStorageService: LocalStorageService,private utilityService: UtilityService){
        this.timezone = this.utilityService.timeZone;
    }
    transform(value: any,withUTC = false, format ='', timeZone: string = this.timezone, timeZoneFormat= false): any {
        if (value) {
            value = format === '' ? dayjs(value) : dayjs(value, format);
            if(withUTC){
                value = value.utc(true).tz(timeZone).format(timeZoneFormat && this.utilityService.isTimeZoneEnabled
                    ? `${this.timeFormatObject[this.timeFormat]} z` : this.timeFormatObject[this.timeFormat]);
            }else {
                value = value.tz(timeZone).format(timeZoneFormat && this.utilityService.isTimeZoneEnabled ?
                    `${this.timeFormatObject[this.timeFormat]} z` : this.timeFormatObject[this.timeFormat]);
            }
        }
        return value;
    }
    transformWithTz(value: any, format: any): any {
        if (value) {
            value = dayjs(value, format).utc(true).tz(this.timezone).format(this.timeFormatObject[this.timeFormat]);
        }
        return value;
    }
}
